module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/smvZNt/tc-custom/9781440579424.jpg?1730536629725",
      "alt": "This image is the cover for the book Totally Washi!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Totally Washi!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Stick on the fun!"), _c('br'), _c('br'), _vm._v("Say hello to a whole new way of decorating! With "), _c('i', [_vm._v("Totally Washi!")]), _vm._v(", you'll learn how to use washi tape, a colorful Japanese crafting tape, to transform everyday items into adorable creations everyone will love. Featuring 50 awesome washi tape projects, this book encourages you to let your imagination roam free as you cover your locker, bedroom, and even your friends' accessories in the stylish tape. Best of all, when you're bored with the look, you can simply peel off the tape and start all over again! The possibilities are endless with fun washi tape crafts like:Cloud & raindrop bookmarkBraided friendship braceletsCutout art framesBobby pin flowerLocker dry erase board Complete with step-by-step instructions and full-color photos, "), _c('i', [_vm._v("Totally Washi!")]), _vm._v(" will show you how to customize just about anything!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Ashley Ann Laz\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Adams Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0